import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  ', ';\n  ', ';\n'], ['\n  ', '\n  ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      opacity: 0.3;\n      pointer-events: none;\n    '], ['\n      opacity: 0.3;\n      pointer-events: none;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      background-color: ', ';\n    '], ['\n      background-color: ', ';\n    ']);

import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import injected from '../injected';

import { utils, translations, styles } from 'gipsy-misc';

import { panelStyle, Scrollable, Body } from '../Panel';
import Header from './components/Header';
import Prompt from './components/Prompt';
import Footer from './components/Footer';

var View = function (_PureComponent) {
  _inherits(View, _PureComponent);

  function View() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, View);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = View.__proto__ || Object.getPrototypeOf(View)).call.apply(_ref, [this].concat(args))), _this), _this.getTaskPanelColor = function (reviewTypeHeader) {
      switch (reviewTypeHeader) {
        case utils.taskpanel.needReviewAsReviewer || utils.taskpanel.reviewedReviewAsReviewer:
          return '#faf9fa';
        default:
          return undefined;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(View, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.panel && this.panel.scrollTo && this.panel.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mode = _props.mode,
          loading = _props.loading,
          fields = _props.fields,
          closeAllFields = _props.closeAllFields,
          activePrompt = _props.activePrompt,
          consentDelete = _props.consentDelete,
          denyDelete = _props.denyDelete,
          editMode = _props.editMode,
          closePanel = _props.closePanel,
          task = _props.task;


      var promptMessage = editMode === 'recurring' ? translations.taskPanel.delete.promptRecurring : translations.taskPanel.delete.prompt;

      var _utils$task$getTaskDa = utils.task.getTaskDataForUser(task, injected.user),
          isAssignee = _utils$task$getTaskDa.isAssignee,
          isReviewer = _utils$task$getTaskDa.isReviewer,
          reviewStatus = _utils$task$getTaskDa.reviewStatus,
          hasReviewerWithStatusPending = _utils$task$getTaskDa.hasReviewerWithStatusPending,
          hasReviewerWithStatusReopened = _utils$task$getTaskDa.hasReviewerWithStatusReopened,
          isReviewedByAllReviewers = _utils$task$getTaskDa.isReviewedByAllReviewers;

      var reviewHeaderType = utils.taskpanel.getReviewHeaderType({
        isAssignee: isAssignee,
        isReviewer: isReviewer,
        reviewStatus: reviewStatus,
        hasReviewerWithStatusPending: hasReviewerWithStatusPending,
        hasReviewerWithStatusReopened: hasReviewerWithStatusReopened,
        isReviewedByAllReviewers: isReviewedByAllReviewers
      });

      var taskPanelColor = this.getTaskPanelColor(reviewHeaderType);

      return React.createElement(
        TaskPanel,
        {
          mode: mode,
          loading: loading ? 1 : 0,
          className: 'task-panel',
          onClick: closeAllFields,
          backgroundColor: taskPanelColor },
        React.createElement(
          Scrollable,
          { id: 'panel-scrollable', className: 'panel-scrollable', ref: function ref(_ref2) {
              return _this2.panel = _ref2;
            } },
          React.createElement(Header, {
            editMode: editMode,
            mode: mode,
            task: task,
            reviewHeaderType: reviewHeaderType,
            onEditModeChange: this.props.onEditModeChange,
            onChange: this.props.onChange,
            onChangeReview: this.props.onChangeReview,
            closePanel: closePanel,
            handleAPIError: this.props.handleAPIError,
            progressPending: this.props.progressPending,
            progressSuccess: this.props.progressSuccess,
            progressError: this.props.progressError,
            approveReview: this.props.approveReview,
            reopenReview: this.props.reopenReview
          }),
          React.createElement(
            Body,
            { className: 'panel-body', activePrompt: activePrompt },
            fields.filter(function (f) {
              return f.isActive;
            }).map(function (field) {
              var component = field.component,
                  _field$props = field.props,
                  props = _field$props === undefined ? {} : _field$props,
                  rest = _objectWithoutProperties(field, ['component', 'props']);

              var Field = component;
              if (component && typeof component === 'string') {
                Field = require('./fields/' + component + '/index.js').default;
              }
              if (!Field) {
                return null;
              }
              var additionalProps = {
                mode: mode
              };
              for (var key in props) {
                additionalProps[key] = get(_this2.props, props[key]);
              }
              return React.createElement(Field, _extends({ key: 'f-' + rest.id }, rest, additionalProps));
            })
          )
        ),
        React.createElement(Footer, _extends({ creator: task.creator, creationTime: task.creationTime }, this.props)),
        React.createElement(Prompt, {
          active: activePrompt,
          message: promptMessage,
          onConsent: consentDelete,
          consentMessage: translations.taskPanel.delete.consent,
          onDeny: denyDelete,
          denyMessage: translations.taskPanel.delete.deny
        })
      );
    }
  }]);

  return View;
}(PureComponent);

View.propTypes = {
  mode: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  task: PropTypes.object,
  fields: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onChangeReview: PropTypes.func.isRequired,
  activateField: PropTypes.func.isRequired,
  toggleField: PropTypes.func.isRequired,
  create: PropTypes.func,
  closePanel: PropTypes.func,
  togglePrompt: PropTypes.func,
  activePrompt: PropTypes.bool,
  consentDelete: PropTypes.func,
  denyDelete: PropTypes.func,
  disabled: PropTypes.bool,
  notifications: PropTypes.array,
  handleAPIError: PropTypes.func,
  progressPending: PropTypes.func,
  progressSuccess: PropTypes.func,
  progressError: PropTypes.func,
  approveReview: PropTypes.func,
  reopenReview: PropTypes.func
};


export default View;

var TaskPanel = styled.div(_templateObject, panelStyle, function (props) {
  return props.loading && css(_templateObject2);
}, function (props) {
  return props.backgroundColor && css(_templateObject3, props.backgroundColor);
});
//# sourceMappingURL=view.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/view.js
// module id = 1091
// module chunks = 0